import { render, staticRenderFns } from "./teacherFeatured.vue?vue&type=template&id=247e6a74&scoped=true&"
import script from "./teacherFeatured.js?vue&type=script&lang=js&"
export * from "./teacherFeatured.js?vue&type=script&lang=js&"
import style0 from "./teacherFeatured.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./teacherFeatured.vue?vue&type=style&index=1&id=247e6a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247e6a74",
  null
  
)

export default component.exports